import styled from 'styled-components';

export const Container = styled.div`
  .search-input {
    max-width: 200px;
  }
`;



// WEBPACK FOOTER //
// ./src/admin/pages/PendingEvents/styles.js